import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'preline',
  standalone: true
})
export class PreLinePipe implements PipeTransform {

  transform(val: string | undefined, replaceWith?: string): unknown {
    // console.log('val = ',val)
    if (!val) {
      return undefined;
    }
    let result= val.replace(/\\n\\r/g, replaceWith || "&#10;");
    // console.log('before replace = ', val, ' after replace = ', result);
    return result;
  }
}
